import { Helmet } from "react-helmet";
import iconOne from "../images/Section-4/icon_1.png";
import iconTwo from "../images/Section-4/icon_2.png";
import iconThree from "../images/Section-4/icon_3.png";
import iconFour from "../images/Section-4/icon_4.png";

export default function SectionFour({ openModal }: any) {
  return (
    <div>

      <section className="bg-white flex items-center justify-center px-6 font-poppins relative">
        <Helmet>
          <title>Transform Your Practice | DUMOSH Growth</title>
          <meta
            name="description"
            content="Achieve 300% growth in 3 months with DUMOSH. Packed appointment schedules, zero missed opportunities, and consistent practice growth."
          />
          <meta
            name="keywords"
            content="practice growth,   appointments, medical marketing, clinic expansion"
          />
          <meta
            property="og:title"
            content="Transform Your Practice | DUMOSH Growth"
          />
          <meta
            property="og:description"
            content="We guarantee 300% growth in 3 months. Discover how DUMOSH can transform your practice today."
          />
          <meta property="og:type" content="website" />
        </Helmet>

        <div className="max-w-4xl w-full flex flex-col items-center text-center">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-blue-500 mb-2">
            The Results <span className="block"> You Can Expect</span>
          </h2>
          <p className="md:text-2xl text-xl font-semibold text-gray-700">
            Real Results, Real Growth
          </p>
          <p className="md:text-md text-sm text-gray-500 mb-10">
            See the Difference Dumosh Can Make
          </p>

          {/* Grid Icons */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:gap-10 gap-3">
            <div className="bg-blue-500 text-white rounded-[32px] p-6 flex flex-col items-center shadow-md">
              <img src={iconOne} alt="Higher Lead Conversion" className="md:w-24 w-12 md:h-24 h-12 mb-4" />
              <p className="font-semibold md:text-md text-sm">Higher Lead <span className="md:block inline">Conversion</span> </p>
            </div>

            <div className="bg-blue-100 text-blue-600 rounded-[32px] p-6 flex flex-col items-center shadow-md">
              <img src={iconTwo} alt="Reduced No-Shows" className="md:w-24 w-12 md:h-24 h-12 mb-4" />
              <p className="font-semibold md:text-md text-sm">Reduced <span className="md:block inline">No-Shows</span> </p>
            </div>

            <div className="bg-blue-100 text-blue-600 rounded-[32px] p-6 flex flex-col items-center shadow-md">
              <img src={iconThree} alt="Improved   Satisfaction" className="md:w-24 w-12 md:h-24 h-12 mb-4" />
              <p className="font-semibold md:text-md text-sm text-center">Improved   <span className="md:block inline">Satisfaction</span></p>
            </div>

            <div className="bg-blue-500 text-white rounded-[32px] p-6 flex flex-col items-center shadow-md">
              <img src={iconFour} alt="Scalable Growth" className="md:w-24 w-12 md:h-24 h-12 mb-4" />
              <p className="font-semibold md:text-md text-sm">Scalable <span className="md:block inline">Growth</span></p>
            </div>
          </div>

          {/* Button
        <button
          onClick={openModal}
          className="bg-[#E91212] text-white px-6 py-2 md:px-8 md:py-3 rounded-xl font-bold text-sm md:text-xl hover:bg-[#e34242] transition-transform duration-300 transform hover:scale-105"
        >
          Discover How
        </button> */}

        </div>

      </section>
      {/* Right Content */}
      <div className="w-full bg-white font-poppins px-4 md:px-6 lg:px-8 py-10">
        <div className="max-w-5xl mx-auto">
          <div className="w-full">
            <iframe
              className="w-full h-40 sm:h-80 md:h-96 lg:h-[300px] xl:h-[500px] 2xl:h-[600px] rounded-xl"
              src="https://www.youtube.com/embed/6L5F2Oj5xjg?si=5M2-OJBadKTANnGF"
              title="YouTube video player"
              width="560" height="200"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

    </div>
  );
}
